const HTTP_PROTOCOL =
  typeof location === "undefined" ? "http:" : location.protocol || "http:";

function httpAutoSSL(hostPort: string) {
  return `${HTTP_PROTOCOL}//${hostPort}`;
}

export const URL_ADMIN = httpAutoSSL(location.host);

export const URL_ADMIN_EN = httpAutoSSL(`${location.host}:8091`);
